var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { ListItem as MuiListItem, Container, } from '@mui/material';
/**
 * Pigment [ListItem](https://pigment.customink.com/?path=/docs/components-listItem)
 */
var ListItem = forwardRef(function (_a, ref) {
    var startIcon = _a.startIcon, endIcon = _a.endIcon, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, children = _a.children, props = __rest(_a, ["startIcon", "endIcon", "variant", "children"]);
    return (React.createElement(MuiListItem, __assign({ ref: ref, className: variant, tabIndex: 0 }, props),
        startIcon,
        React.createElement(Container, { disableGutters: true }, children),
        endIcon));
});
export default ListItem;
//# sourceMappingURL=ListItem.js.map